import React from 'react';
import Moment from 'moment'
import { roundNum } from 'utils/numbers';
import SectionTitle from './SectionTitle';

const InfoSection = ({ assessment }) => {
  return (
    <div className="template-section">
      <SectionTitle title="General Info" />
      <div className="general-info-list">
        <div className="general-info-view">
          <p>
            <label>Gender</label>
            {assessment?.gender ? 
              <span>{ assessment?.gender }</span>
            :
            <span>{ `unavailable` }</span>
            }
          </p>
          <p>
            <label>Birthdate</label>
            {assessment?.birthday ? 
              <span>{ Moment(assessment?.birthday).format('DD-MM-YYYY') }</span>
            :
              <span>{ `unavailable` }</span>
            }
          </p>
          <p>
            <label>Height</label>
            {assessment?.height ? 
              <span>{ `${assessment?.height?.value} ${assessment?.height?.measurement_unit}` }</span>
              :
              <span>{ `unavailable` }</span>
            }
          </p>
          <p>
            <label>Weight</label>
            { assessment?.weight ?
              <span>{ `${assessment?.weight?.value} ${assessment?.weight?.measurement_unit}` }</span>
            :
              <span>{ `unavailable` }</span>
            }
          </p>
          <p>
            <label>Body Fat Percentage</label>
            {assessment?.body_fat_percentage ? 
              <span>{ `${roundNum(Number(assessment?.body_fat_percentage))} %` }</span>
            :
              <span>{ `unavailable` }</span>
            }
          </p>
          {/* <p>
            <label>Body Mass Index</label>
            <span>13</span>
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default InfoSection;
